export default {"src":"/_next/static/media/icon_play_recommended.1387e138.svg","height":80,"width":74,"blurWidth":0,"blurHeight":0};